import { useEffect } from 'react'

import {
  backgrounds as multiBackgrounds,
  backgroundsShadow as multiBackgroundsShadow,
} from 'components/block/ControlButtonsBar/assets/button/double/backgroundImages'
import {
  backgrounds as singleBackgrounds,
  backgroundsShadow as singleBackgroundShadows,
} from 'components/block/ControlButtonsBar/assets/button/single/backgroundImages'
import heartsSvg from 'components/page/RatingWave/block/LikeAnimation/assets/svg/heart-icons-like.svg'
import { cacheImages } from 'functions/cache/cacheImages'

/**
 * Background кнопок для рейтинга и профиля.
 * @returns
 */
export const useCacheSvg = () => {
  useEffect(() => {
    cacheImages(multiBackgrounds)
    cacheImages(multiBackgroundsShadow)
    cacheImages(singleBackgrounds)
    cacheImages(singleBackgroundShadows)
    cacheImages([heartsSvg])
  }, [])

  return null
}
